import { NavigateFunction } from "react-router-dom";


let navigateRef: NavigateFunction;

export const setNavigate = (navigate: NavigateFunction) => {
  navigateRef = navigate;
};

export const navigate = (path: string) => {
  if (navigateRef) {
    navigateRef(path);
  }
};